export default "__VITE_ASSET__CEjcMHL5__"